import { render } from "./TeacherSubjectShow.vue?vue&type=template&id=50896c60&scoped=true"
import script from "./TeacherSubjectShow.vue?vue&type=script&lang=js"
export * from "./TeacherSubjectShow.vue?vue&type=script&lang=js"

import "./TeacherSubjectShow.vue?vue&type=style&index=0&id=50896c60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50896c60"]])

export default __exports__